import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { useSelector } from "react-redux";
import classes from "./AssessmentDetails.module.css";

const AssessmentDetails = forwardRef(({ setValid, assessment, handleChangeBaseProperties }, ref) => {

    const texts = useSelector(state => state.translate.texts);
    const charactersNum = 20
    const descriptionCharactersNum = 60

    const [assessmentName, setAssessmentName] = useState("")
    const [description, setDescription] = useState("")

    useEffect(() => {
        if (assessment.id) {
            // get assessment details from API and set them in the obj
            setAssessmentName(assessment.name)
            setDescription(assessment.description)
            setValid(true)
        } else {
            setValid(false)
        }
    }, [assessment.id])

    useImperativeHandle(ref, () => ({
        async stepNext() {
            handleChangeBaseProperties(assessmentName, description)
        }
    }))

    const debounce = (func, delay) => {
        let debounceTimer;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(debounceTimer);
            debounceTimer =
                setTimeout(() => func.apply(context, args), delay);
        }
    }
    const handleChange = (event) => {
        event.persist();
        if (event.target.name === "assessmentDescription") {
            setDescription(event.target.value);
            if (assessment.id) {
                handleChangeBaseProperties(assessmentName, event.target.value)
            }
        } else if (event.target.name === "assessmentName") {
            setAssessmentName(event.target.value);
            setValid(true)
            if (assessment.id) {
                handleChangeBaseProperties(event.target.value, description)
            }
            if (event.target.name === "") {
                setValid(false)
            }
        }
    }
    let optimisedHandleChange = debounce(handleChange, 700);

    return (
        <div className={classes.AssessmentDetailsWrapper}>
            <div className={classes.AssessmentDetails}>
                <div className={classes.AssessmentName}>
                    <div className={classes.Text}>
                        <h2 className={`${classes.Title}`}>{texts.assessmentName}</h2>
                        <div className={classes.UpToCharacters}>({texts.upTo} {charactersNum} {texts.characters})</div>
                    </div>
                    <div className={classes.AssessmentNameInputWrapper}>
                        <input type='text'
                            name="assessmentName"
                            defaultValue={assessment.name}
                            // placeholder={assessment.name}
                            className={`${classes.Input} ${classes.AssessmentNameInput}`}
                            onChange={optimisedHandleChange}
                            maxLength={charactersNum}
                        />
                        <div className={classes.CharactersNum}>{assessmentName.length}/{charactersNum} {texts.characters}</div>
                    </div>
                </div>
                <div className={classes.Description}>
                    <div className={classes.Text}>
                        <h2 className={`${classes.Title}`}>{texts.description}</h2>
                        <div className={classes.UpToCharacters}>({texts.upTo} {descriptionCharactersNum} {texts.characters})</div>
                    </div>
                    <div className={classes.DescriptionInputWrapper}>
                        <input type='text'
                            name="assessmentDescription"
                            defaultValue={assessment.description}
                            // placeholder={assessment.description}
                            className={`${classes.Input} ${classes.DescriptionInput}`}
                            onChange={optimisedHandleChange}
                            maxLength={descriptionCharactersNum}
                        />
                        <div className={classes.CharactersNum}>{description?.length}/{descriptionCharactersNum} {texts.characters}</div>
                    </div>
                </div>
            </div>
        </div>
    )
})

export default AssessmentDetails;